const buildPeriodColumns = (formattedData) => {
  return Object.keys(formattedData || {}).sort();
};

const formatPeriodColumn = (period) => {
  const periodText = String(period);
  if (/^\d{6}$/.test(periodText)) {
    return `${periodText.substring(4, 6)}-${periodText.substring(0, 4)}`;
  }
  return periodText;
};

const normalizeValue = (value) => {
  if (value === null || value === undefined) return "";
  return String(value);
};

export const buildDynamicPanelTable = ({
  columnsGroupsOrder = [],
  formattedData = {},
}) => {
  const periods = buildPeriodColumns(formattedData);
  const columns = periods.map(formatPeriodColumn);
  const rows = [];
  const excelRows = [];

  columnsGroupsOrder.forEach((group) => {
    Object.entries(group).forEach(([groupLabel, metricLabels]) => {
      const dividerRow = {
        label: groupLabel,
        category: "divider",
        data: periods.map(() => ""),
      };

      rows.push(dividerRow);
      excelRows.push({ data: [groupLabel, ...dividerRow.data] });

      metricLabels.forEach((metricLabel) => {
        const rowData = periods.map((period) =>
          normalizeValue(formattedData[period]?.[metricLabel]),
        );
        rows.push({
          label: metricLabel,
          category: "data",
          data: rowData,
        });
        excelRows.push({ data: [metricLabel, ...rowData] });
      });
    });
  });

  return { columns, rows, excelRows };
};
